// extracted by mini-css-extract-plugin
export default {"table":"VotingTable_table__7rsQE","buttonGroup":"VotingTable_buttonGroup__Wz1cn"};